module.exports = __webpack_public_path__ + "static/img/card2.6309ef7a.svg";